import { ChangeDetectorRef, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {
  ClientQuestionnaireResultBase,
} from '../../../../../../modules/src/lib/questionnaires/components/base-client-questionnaire/form/base-result/client-questionnaire-result.base';
import {
  MainSpouseQuebec2022TaxQuestionnaireOptions,
} from '../../../../../../../../common/src/options/client-questionnaire/quebec-2022-tax-questionnaire/main-spouse-quebec-2022-tax-questionnaire.options';
import {
  Quebec2022TaxFormResultFactory,
} from '../../../../../../modules/src/lib/questionnaires/components/quebec-2022-tax-questionnaire/result/quebec-2022-tax-form-result/quebec-2022-tax-form-result.factory';
import {
  ClientQuestionnaireStore,
} from '../../../../../../modules/src/lib/questionnaires/stores/client-questionnaire.store';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateUtils } from '../../../../../../modules/src/lib/core/utils/date.utils';
import { AlertMessageStore } from '../../../../../../modules/src/lib/core/stores/alert-message.store';
import {OptionsMapper} from "@magieno/angular-advanced-forms";

@Component({
  selector: 'app-notify-client-questionnaires',
  templateUrl: './notify-client-questionnaire.component.html',
  styleUrls: ['./notify-client-questionnaire.component.scss'],
  standalone: false,
})
export class NotifyClientQuestionnaireComponent extends ClientQuestionnaireResultBase<MainSpouseQuebec2022TaxQuestionnaireOptions> {

  hasCopied = false;

  constructor(public readonly formFactory: Quebec2022TaxFormResultFactory,
              clientQuestionnaireStore: ClientQuestionnaireStore,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              dateUtils: DateUtils,
              // calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              private readonly changeDetectorRef: ChangeDetectorRef) {
    super(formFactory, clientQuestionnaireStore, translateService, activatedRoute, router, optionsMapper, dateUtils, alertMessageStore);
    this.optionsType = MainSpouseQuebec2022TaxQuestionnaireOptions;
  }

  getLink() {
    if (this.clientQuestionnaireResponse === undefined) {
      return 'Chargement...';
    }

    return environment.clientPortal.host + '/questionnaires/' + this.clientQuestionnaireResponse.keyname + '/' + this.clientQuestionnaireResponse.id;
  }

  copyToClipboard() {
    this.hasCopied = true;
    return navigator.clipboard.writeText(this.getLink());
  }

  mailtoLink() {
    return 'mailto:' + this.getClientEmail() + '?subject=Vous avez un questionnaire pour vos impôts à remplir&body=Bonjour ' + this.getClientName() + ', %0D%0A%0D%0AC\'est déjà la saison des impôts. Afin de faciliter la collecte de vos données, voici le lien vers un questionnaire électronique à remplir: ' + this.getLink() + '  %0D%0A%0D%0AVous devez vous connecter avec le email suivant:\'' + this.getClientEmail() + '\'. %0D%0A%0D%0ALaissez-moi savoir si vous avez des questions!';
  }

}
